import { BackendApi } from "./HttpBaseService";

// Eventos de temporada (Prueba de Admisión, Desfile Inaugural, Escuelas de
// Samba, Llamadas). Contrato v1 del 2026-11-01, endpoints admin de Evento.
const ObtenerEventosAdmin = async () => await BackendApi.get(`Evento/admin`);

const ObtenerEventoAdmin = async id => await BackendApi.get(`Evento/${id}/admin`);

const CrearEvento = async evento => await BackendApi.post(`Evento`, evento);

const ModificarEvento = async (id, evento) => await BackendApi.put(`Evento/${id}`, evento);

const CambiarPublicadoEvento = async (id, publicado) =>
  await BackendApi.put(`Evento/${id}/publicado`, { publicado });

const EliminarEvento = async id => await BackendApi.delete(`Evento/${id}`);

const PrevisualizarProgramacionEvento = async (id, texto) =>
  await BackendApi.post(`Evento/${id}/programacion/previsualizar`, { texto });

const GuardarProgramacionEvento = async (id, programacion) =>
  await BackendApi.put(`Evento/${id}/programacion`, programacion);

const PrevisualizarFallosEvento = async (id, texto) =>
  await BackendApi.post(`Evento/${id}/fallos/previsualizar`, { texto });

const GuardarFallosEvento = async (id, fallos) => await BackendApi.put(`Evento/${id}/fallos`, fallos);

const PublicarFallosEvento = async (id, notificar, modoPrueba) =>
  await BackendApi.post(`Evento/${id}/publicar-fallos`, null, { params: { notificar, modoPrueba } });

const OcultarFallosEvento = async id => await BackendApi.post(`Evento/${id}/ocultar-fallos`);

const EventoService = {
  ObtenerEventosAdmin,
  ObtenerEventoAdmin,
  CrearEvento,
  ModificarEvento,
  CambiarPublicadoEvento,
  EliminarEvento,
  PrevisualizarProgramacionEvento,
  GuardarProgramacionEvento,
  PrevisualizarFallosEvento,
  GuardarFallosEvento,
  PublicarFallosEvento,
  OcultarFallosEvento
};

export default EventoService;
